import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./stores/user-store"; // Import the functions you need from the SDKs you need
import { auth } from "./firebaseConfig"; // Import auth from firebaseConfig.js
import "@/styles/styles.scss";

createApp(App).use(router).use(store).use(auth).mount("#app");
